/**
 * Generate a cryptographically secure hexadecimal string.
 *
 * @param byteLength Number of random bytes to generate.
 */
export function generateSecureHex(byteLength: number) {
    if (!globalThis.crypto?.getRandomValues) {
        throw new Error("Web Crypto API is unavailable");
    }

    const bytes = new Uint8Array(byteLength);
    globalThis.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

/** Generate a client identifier suitable for an integration client. */
export function generateIntegrationClientId() {
    return `integration-${generateSecureHex(12)}`;
}

/** Generate a 32-byte integration client secret. */
export function generateIntegrationClientSecret() {
    return generateSecureHex(32);
}
